module.exports = __webpack_public_path__ + "static/heller2-2e2c1ced04d5193344f31f9d2af38b0e.jpg";